export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const RESET_MESSAGE_STORE = 'RESET_MESSAGE_STORE';
